import React from "react";
import { Box } from "@mui/material";
import Row from "../../../components/Row";
import { colors } from "../../../utils/constants";
import EventIcon from "@mui/icons-material/Event";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import BarChartIcon from "@mui/icons-material/BarChart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconBadge from "../components/IconBadge";
import { landingTokens } from "../theme";

interface FeaturesProps {
  isMobile: boolean;
}

const features = [
  {
    icon: <EventIcon />,
    title: "Crie seu evento",
    text: (
      <>
        Crie seu evento, com <strong>banner, template do certificado, senha de cada dia</strong>,
        e porcentagem de presença necessária para o evento. Tudo isso com poucos cliques, baixe o{" "}
        <strong>QR Code</strong> do evento e <strong>divulgue para seus alunos</strong>.
      </>
    ),
  },
  {
    icon: <WorkspacePremiumIcon />,
    title: "Emita certificados",
    text: (
      <>
        Os alunos fazem <strong>checkin com uma senha em cada dia</strong>, permitindo emitir seus
        certificados no final do evento.{" "}
        <strong>
          Automatizando a emissão de certificados e garantindo que só quem realmente participou,
          terá o certificado
        </strong>
        .
      </>
    ),
  },
  {
    icon: <BarChartIcon />,
    title: "Obtenha dados",
    text: (
      <>
        O criador do evento tem acesso aos dados de checkin:{" "}
        <strong>
          quantos checkins realizados, quantos completos, quem fez checkin em tal dia...
        </strong>{" "}
        Possibilitando um <strong>marketing mais direto</strong> para as pessoas que realmente
        participaram.
      </>
    ),
  },
];

function Features({ isMobile }: FeaturesProps) {
  const styles = {
    container: {
      backgroundColor: colors.white,
      padding: isMobile ? 4 : 10,
      paddingLeft: isMobile ? 4 : 16,
      paddingRight: isMobile ? 4 : 16,
    },
    title: {
      fontSize: isMobile ? 22 : 32,
      fontWeight: 600,
      color: colors.primary,
      width: isMobile ? "100%" : "25%",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
    },
    descriptionFeature: {
      fontSize: 16,
      width: isMobile ? "100%" : "60%",
      paddingLeft: isMobile ? 0 : 120,
      textAlign: "left" as const,
      marginTop: isMobile ? 20 : 0,
    },
    featureCard: {
      padding: isMobile ? 3 : 4,
      borderRadius: `${landingTokens.radius.card}px`,
      backgroundColor: colors.white,
      border: "1.5px solid #E5E9F0",
      gap: 2,
      flexDirection: "column" as const,
      display: "flex",
      alignItems: "flex-start",
      textAlign: "left" as const,
      marginTop: isMobile ? 3 : 0,
      transition: landingTokens.transition,
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: landingTokens.shadow,
        borderColor: colors.primary,
      },
    },
    featureTitle: {
      fontSize: isMobile ? 18 : 22,
      color: "#14213D",
      fontWeight: 700,
      marginTop: 8,
    },
    featureText: {
      fontSize: 15,
      color: "#5B6472",
      fontWeight: 400,
      textAlign: "left" as const,
      lineHeight: 1.6,
    },
  };

  return (
    <Box sx={styles.container}>
      <Row style={{ flexDirection: isMobile ? "column" : "row" }}>
        <Box component="span" sx={styles.title}>
          <CheckCircleIcon sx={{ color: colors.primary }} /> Para quem precisa emitir certificados
        </Box>
        <span style={styles.descriptionFeature}>
          Uma plataforma completa para <strong>automatizar emissão de certificados</strong> de
          participação, garantindo que{" "}
          <strong>
            somente quem realmente participou do evento possa emitir o certificado
          </strong>{" "}
          de participação. Tornando tudo muito mais <strong>seguro, ágil e fácil</strong>.
        </span>
      </Row>
      <Row
        style={{
          marginTop: isMobile ? 40 : 80,
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 16 : 32,
        }}
      >
        {features.map((feature) => (
          <Box key={feature.title} sx={styles.featureCard}>
            <IconBadge icon={feature.icon} />
            <span style={styles.featureTitle}>{feature.title}</span>
            <span style={styles.featureText}>{feature.text}</span>
          </Box>
        ))}
      </Row>
    </Box>
  );
}

export default Features;
